export default "__VITE_ASSET__DjxWnsLC__"